<template>
  <div v-if="quests" class="tasks">
    <!-- REFACTOR QUEST ITEM ON FURTHER VISIT INTO COMPONENTS -->

    <div
      v-for="(chunk, chunkIndex) in questChunks"
      class="wrapper"
      :key="chunkIndex"
    >
      <div
        v-for="(quest, index) in chunk"
        :key="index"
        :class="{ 'has-share': quest.vk || quest.fb }"
        class="task-item"
      >
        <div
          v-if="quest.vk || quest.fb"
          key="social_quest"
          @click="openQuest = true"
        >
          <div class="img">
            <img
              :src="
                quest.data.pic.replace(
                  'sailplays3.cdnvideo.ru',
                  'sailplays3-ua.cdnvideo.net'
                )
              "
            />
          </div>
          <span class="head">{{ quest.data.name }}</span>
          <span class="ball">
            +{{ quest.content.message || 0 }}
            {{ quest.content.message | pluralize("point,points,points") }}
          </span>
        </div>

        <a
          v-else-if="quest._actionId && !quest.vk && !quest.fb"
          key="custom_quest"
          v-system-action="quest"
          @click="openQuest = true"
        >
          <div class="img">
            <img
              :src="
                quest.icon.replace(
                  'sailplays3.cdnvideo.ru',
                  'sailplays3-ua.cdnvideo.net'
                ) ||
                quest.data.pic.replace(
                  'sailplays3.cdnvideo.ru',
                  'sailplays3-ua.cdnvideo.net'
                )
              "
            />
          </div>
          <span class="head">{{ quest.name || quest.data.name }}</span>
          <span class="ball">
            +{{ quest.content.message || 0 }}
            {{ quest.content.message | pluralize("point,points,points") }}
          </span>
        </a>

        <div
          v-else-if="!quest._actionId"
          key="custom_quest"
          @click="
            onOpenCustom(quest);
            openQuest = true;
          "
        >
          <div class="img">
            <img
              :src="
                quest.icon.replace(
                  'sailplays3.cdnvideo.ru',
                  'sailplays3-ua.cdnvideo.net'
                )
              "
            />
          </div>
          <span class="head">{{ quest.name }}</span>
          <span class="ball">
            +{{ quest.content.message || 0 }}
            {{ quest.content.message | pluralize("point,points,points") }}
          </span>
        </div>

        <div class="plaque" :class="plaque(quest).color" v-if="plaque(quest)">
          {{ plaque(quest).text }}
        </div>
      </div>
    </div>

    <transition name="s_popup_transition">
      <div v-if="openQuest" class="popup">
        <div
          class="popup-inner popup-inner-gift popup-inner-gift-quest"
          v-on-clickaway="
            () => {
              openQuest = false;
            }
          "
        >
          <a href="#" class="close" @click.prevent="openQuest = false"></a>
          <div class="info">
            <span class="name"> {{ open.name }} </span>
            <span class="desc" v-html="open.description"> </span>
            <a @click.prevent href="#" class="red-btn">
              +{{ open.content.message }}
              {{ open.content.message | pluralize("point,points,points") }}
            </a>
          </div>
          <div class="img">
            <img
              :src="
                (open.content &&
                  open.content.image.replace(
                    'sailplays3.cdnvideo.ru',
                    'sailplays3-ua.cdnvideo.net'
                  )) ||
                open.data.pic.replace(
                  'sailplays3.cdnvideo.ru',
                  'sailplays3-ua.cdnvideo.net'
                )
              "
            />
          </div>
          <!-- <div class="bottom">
                    To receive the award for successful execution of this action please submit your recognition request to your manager or to hr@placeholder.com.
                </div> -->
        </div>
      </div>
    </transition>

    <!--<div v-if="open" class="popup">-->
    <!--<div v-if="open._actionId" key="open_social" class="popup-inner popup-inner-quest">-->
    <!--<div class="img"></div>-->
    <!--<span class="head">{{ open.data.name }}</span>-->
    <!--<span class="ball">-->
    <!--+{{ open.data.points }} {{ open.data.points | pluralize('point,points,points') }}-->
    <!--</span>-->
    <!--<div v-system-action="open">{{ open.data.button_text }}</div>-->
    <!--</div>-->

    <!--<div v-else-if="!open._actionId" key="open_custom" class="popup-inner popup-inner-iframe">-->
    <!--<iframe class="custom-iframe" :src="open | customIframe"></iframe>-->
    <!--</div>-->

    <!--</div>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CONFIG from "../../config";
import { directive as onClickaway } from "vue-clickaway2";
const SAILPLAY = window.SAILPLAY;
let DEFAULT_BUTTON = {
  "font-size": "15px",
  "font-weight": "bold",
  display: "inline-block",
  color: "#ffffff",
  "line-height": "40px",
  "background-color": "#cd3c3c",
  padding: "0 30px",
  "text-decoration": "none",
  "font-family": "Arial",
  cursor: "pointer",
};
const DEFAULT_STYLES = {
  fb_share_btn: DEFAULT_BUTTON,
  vk_share_btn: DEFAULT_BUTTON,
};
const PLAQUE_COLORS = {
  new: "green",
  updated: "blue",
};
const CHUNK_SIZE = 5;
const DELAY_AFTER_SUCCESS = 2000;
const stringifyCss = (prefix, obj) => {
  let css_string = "";
  let media_queries = "";

  for (let selector in obj) {
    if (obj.hasOwnProperty(selector)) {
      if (selector[0] == "@" && selector.split("|").length > 1) {
        var media = selector.split("|")[0].trim();
        var cls = selector.split("|")[1].trim();
        media_queries += media + "{ " + prefix + " ." + cls + "{ ";
      } else css_string += prefix + " ." + selector + "{ ";

      let selector_styles = obj[selector];

      for (let prop in selector_styles) {
        if (selector_styles.hasOwnProperty(prop)) {
          if (selector[0] == "@") {
            media_queries +=
              prop + ":" + selector_styles[prop] + " !important;";
          } else {
            css_string += prop + ":" + selector_styles[prop] + " !important;";
          }
        }
      }

      if (selector[0] == "@") media_queries += " } }";
      else css_string += " }";
    }
  }

  css_string += media_queries;
  return css_string;
};
export default {
  name: "AppQuests",
  data() {
    return {
      isMounted: false,
      open: null,
      openQuest: false,
    };
  },
  directives: {
    onClickaway,
    systemAction: {
      bind: (el, binding) => {
        let value = binding.value;
        el.setAttribute(
          "data-styles",
          stringifyCss("", value.data.styles || DEFAULT_STYLES)
        );
        el.setAttribute(
          "data-text",
          value.button_text || value.data.button_text
        );
        SAILPLAY.actions && value && SAILPLAY.actions.parse(el, value);
      },
    },
  },
  watch: {
    open(value) {
      let className = "lock-scroll1";
      if (value) {
        document.getElementsByTagName("body")[0].style.top =
          -document.documentElement.scrollTop + "px";
        document.documentElement.classList.add(className);
      } else {
        document.documentElement.classList.remove(className);
      }
    },
    openQuest(value) {
      let className = "lock-scroll1";
      if (value) {
        document.getElementsByTagName("body")[0].style.top =
          -document.documentElement.scrollTop + "px";
        document.documentElement.classList.add(className);
      } else {
        document.documentElement.classList.remove(className);
      }
    },
  },
  computed: {
    ...mapGetters(["questList", "remoteConfig"]),
    quests() {
      if (!this.isMounted || !this.remoteConfig || !this.questList) return;
      let data = this.remoteConfig.quests;

      let socialsQuests = this.questList.filter((item) => item.socialType);
      let quests = socialsQuests.reduce((total, current) => {
        let item = total.find((item) => item.action === current.action);
        if (!item) {
          let item = {
            _actionId: current._actionId,
            action: current.action,
            [current.socialType]: current,
            data: data.social[current.action],
          };
          total = [...total, item];
        } else {
          item[current.socialType] = current;
        }
        return total;
      }, []);

      let customQuests = this.questList.filter((item) => !item._actionId);
      quests = [
        ...quests,
        ...customQuests.map((item) => {
          item.data = data.custom[item.type];
          return item;
        }),
      ];

      let otherQuests = this.questList.filter(
        (item) => !item.socialType && item._actionId
      );
      quests = [
        ...quests,
        ...otherQuests.map((item) => {
          item.data = data.system[item.type];
          return item;
        }),
      ];

      quests = quests.sort((a, b) =>
        a.content.header > b.content.header ? 1 : -1
      );

      return quests;
    },
    questChunks() {
      var index = 0;
      var arrayLength = this.quests.length;
      var questChunks = [];

      for (index = 0; index < arrayLength; index += CHUNK_SIZE) {
        let chunk = this.filteredQuests.slice(index, index + CHUNK_SIZE);
        // Do something if you want with the group
        questChunks.push(chunk);
      }

      return questChunks;
    },
    filteredQuests() {
      return this.quests.filter((q) => q.type != "points_transfer");
    },
  },
  filters: {
    customIframe(action) {
      let config = SAILPLAY.config();
      return (
        (CONFIG &&
          CONFIG.domain +
            config.urls.actions.custom.render.replace(":action_id", action.id) +
            "?auth_hash=" +
            config.auth_hash +
            "&lang=" +
            config.lang +
            "&config=" +
            (CONFIG.remote_config_name || "default")) ||
        ""
      );
    },
  },
  methods: {
    onOpenSocial(quest, social) {
      let _quest = this.questList.find(
        (item) => quest.action === item.action && item.socialType === social
      );
      _quest.data = quest.data;
      this.open = Object.assign({}, _quest);
    },
    onClosePopup(item) {
      this.open = false;
      if (!this.open._actionId) this.$store.dispatch("fetchQuests");
    },
    onOpenCustom(quest) {
      this.open = Object.assign({}, quest);
    },
    plaque(quest) {
      let text =
        quest.content.button_text &&
        JSON.parse(quest.content.button_text)["plaque"];
      return text
        ? {
            text,
            color: PLAQUE_COLORS[text],
          }
        : null;
    },
  },
  mounted() {
    this.isMounted = true;
  },
  watch: {
    openQuest(value) {
      let className = "lock-scroll";
      if (value) {
        document.getElementsByTagName("body")[0].style.top =
          -document.documentElement.scrollTop + "px";
        document.documentElement.classList.add(className);
      } else {
        document.documentElement.classList.remove(className);
        document.documentElement.scrollTop = -parseFloat(
          document.getElementsByTagName("body")[0].style.top.replace("px", "")
        );
      }
    },
  },
};
</script>
